import {
  AkaAdviceCheckboxes,
  AkaDisabilityAdviceFormValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import {
  AdditionalRestriction,
  CoverageNeed,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import {
  getPayment,
  getPaymentRestriction,
  getRecommended,
  isAllowed,
  isAllowedAmount,
  isDisplayedAndChecked,
} from "Store/akaAdvice/interfaces/getters";
import { getAdviceValueOrMinPayout } from "./utils";

import { OneTimePaymentAdvisorChoice } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import { UserAuthorizationLevel } from "Store/advice/interfaces";

export const mapToIndividualDisabilityFormValues = (
  isAdvisor: boolean,
  need: CoverageNeed,
): Partial<AkaDisabilityAdviceFormValues> => {
  const disabilityCheckbox = isDisplayedAndChecked(
    need,
    ProductCoverageName.DISABILITY_FLEX_PENSION,
  );
  const disabilityInsuredSumCheckbox = isAllowed(
    need,
    ProductCoverageName.DISABILITY_FLEX_PENSION,
  );

  return {
    [AkaAdviceCheckboxes.DISABILITY_CHECKBOX]: disabilityCheckbox,

    incapacityOfWorkCheckbox: false,
    timeLimitedDisabilityInterestCheckbox: false,

    disabilityInsuredSumCheckbox,
    disabilityInsuredSumSlider: getAdviceValueOrMinPayout(
      need,
      ProductCoverageName.DISABILITY_FLEX_PENSION,
      isAdvisor,
    ),
    disabilityPaymentAfter3Months: getPayment(
      need,
      ProductCoverageName.DISABILITY_FLEX_PENSION,
    ).restrictions.additionalRestrictions.includes(
      AdditionalRestriction.ELIGIBLE_FOR_PAYMENT_AFTER_3_MONTHS,
    )
      ? false
      : undefined,

    disabilityOneTimePaymentCheckbox: false,
    disabilityOneTimePaymentValue: getDisabilityCapitalInitialValue(
      need,
      isAdvisor,
    ),
    disabilityOneTimePaymentChangedWarning: undefined,

    disabilityOneTimePaymentAdvisorChoice: isDisplayedAndChecked(
      need,
      ProductCoverageName.DISABILITY_FLEX_CAPITAL,
    )
      ? OneTimePaymentAdvisorChoice.ADVICED_ONE_TIME_PAYMENT
      : OneTimePaymentAdvisorChoice.NO_ONE_TIME_PAYMENT,
    disabilityOneTimePaymentAdvisorValue: undefined,
    disabilityAdviceComment: undefined,
  };
};

const getDisabilityCapitalInitialValue = (
  need: CoverageNeed,
  isAdvisor: boolean,
): number => {
  const recommended = getRecommended(
    need,
    ProductCoverageName.DISABILITY_FLEX_CAPITAL,
  );
  if (
    isAllowedAmount(
      recommended,
      need,
      ProductCoverageName.DISABILITY_FLEX_CAPITAL,
      isAdvisor,
    )
  ) {
    return recommended;
  }
  const authorizationLevel = isAdvisor
    ? UserAuthorizationLevel.PRODUCT_MANAGER
    : UserAuthorizationLevel.CUSTOMER;
  const { maxPayouts, minPayouts } = getPaymentRestriction(
    need,
    ProductCoverageName.DISABILITY_FLEX_CAPITAL,
  );
  const maxPayment = maxPayouts[authorizationLevel];
  const minPayment = minPayouts[authorizationLevel];
  if (minPayment === maxPayment) {
    return maxPayment;
  }
  return 0;
};
